import "./footer.css";
import { useSettings } from "../../context/SettingsContext";
import { ReactComponent as Logo } from "../../assets/images/main-logo-03.svg";
import momo from "../../assets/images/icons/momo.png";
import mbbank from "../../assets/images/icons/mbbank.png";
import vietcombank from "../../assets/images/icons/vietcombank.png";
import techcombank from "../../assets/images/icons/techcombank.png";
import visa from "../../assets/images/icons/visa.png";
import paypal from "../../assets/images/icons/paypal.png";
import { DmcaBadge } from "./DmcaBadge";
import { FaFacebookF, FaTiktok, FaYoutube } from "react-icons/fa";

const BANK_METHOD = [momo, mbbank, vietcombank, techcombank, visa, paypal];

const Footer = () => {
  const { settings } = useSettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mft-root">
      <div className="mft-shell">
        <div className="mft-grid">
          <section className="mft-col mft-col--brand">
            <Logo className="mft-logo" fill="currentColor" />
            <ul className="mft-link-list">
              <li><a className="mft-link" href="/about-us">Giới thiệu</a></li>
              <li><a className="mft-link" href="/term-of-service">Điều khoản dịch vụ</a></li>
              <li><a className="mft-link" href="/privacy-policy">Chính sách bảo mật</a></li>
            </ul>
          </section>

          <section className="mft-col">
            <h3 className="mft-title">Hỗ trợ</h3>
            <ul className="mft-link-list">
              <li>
                <a
                  className="mft-link"
                  href={settings?.contact_messenger_url || "https://messenger.me"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Liên hệ qua Messenger
                </a>
              </li>
              <li>
                <a
                  className="mft-link"
                  href={settings?.contact_zalo_url || "https://zalo.me"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Liên hệ qua Zalo
                </a>
              </li>
            </ul>
          </section>

          <section className="mft-col">
            <h3 className="mft-title">Phương thức thanh toán</h3>
            <div className="mft-payment-grid">
              {BANK_METHOD.map((bank) => (
                <div key={bank} className="mft-payment-item">
                  <img src={bank} alt="payment-method" />
                </div>
              ))}
            </div>
          </section>

          <section className="mft-col">
            <h3 className="mft-title">Theo dõi chúng tôi trên</h3>
            <div className="mft-social-row">
              <a
                className="mft-social-link"
                href={settings?.facebook_url || "https://iampesmobile.com"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                className="mft-social-link"
                href={settings?.tiktok_url || "https://www.tiktok.com/@iampesmobile"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <FaTiktok />
              </a>
              <a
                className="mft-social-link"
                href={settings?.youtube_url || "https://www.youtube.com/@iampesmobile"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
            </div>
          </section>
        </div>

        <div className="mft-dmca-wrap">
          <DmcaBadge />
        </div>

        <div className="mft-bottom">
          <p>© {currentYear} iampesmobile.com. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
